import moment from 'moment';

export const calculateDaysRemaining = (futureDate) => {
  const momentFutureDate = futureDate ? moment(futureDate) : moment()
  const daysRemaining = momentFutureDate.startOf('day').diff( moment().startOf('day'), 'days');
  return daysRemaining;
}

export function isExpiringWithinDays (expiryDate, numberOfDays) {
  const daysRemaining = calculateDaysRemaining(expiryDate)
  return (daysRemaining <= numberOfDays)
}



// WEBPACK FOOTER //
// ./src/features/shared/utils/DateCalculations.js